import React, { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Drawer } from 'shared/ui/Drawer/DrawerPromo';
import { PromoUploadExcel } from 'features/fileUpload/ui/PromoUploadExcel';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { useUploadBonusMutation } from 'features/uploadBonus/api/uploadBonusApi';

type UploadBonusCardPropsType = {
  id: string;
};
export const UploadBonusCard = ({ id }: UploadBonusCardPropsType) => {
  const dispatch = useDispatch();
  const [selectedFileBonuses, setSelectedFileBonuses] = useState<File | null>(null);

  const [uploadFileRequest] = useUploadBonusMutation();

  const onSubmitUploadBonusExcel = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const params = {
      id,
      file: selectedFileBonuses,
    };
    uploadFileRequest(params)
      .then((res: any) => {
        if (res.data) {
          setSelectedFileBonuses(null);
          dispatch(setDrawerOpen(false));
          window.open('/downloads/bonuses', '_blank');
        }
      })
      .catch(() => window.open('/downloads/bonuses', '_blank'));
  };

  return (
    <Drawer title="Загрузить файл бонусов">
      <PromoUploadExcel
        onSubmit={onSubmitUploadBonusExcel}
        setFile={setSelectedFileBonuses}
        file={selectedFileBonuses}
      />
    </Drawer>
  );
};
